import type { TokenTotals } from '@/lib/api/generated/model';

/**
 * The cache share as a sentence (spec 251): "82% of tokens were cache: 67% read, 15%
 * written." Computed from the figures; nothing when no token was cache.
 */
export function cacheShare(totals: TokenTotals): string | null {
  const total = totals.total_tokens;
  const read = totals.cache_read_tokens;
  const written = totals.cache_creation_tokens;
  if (total <= 0 || read + written <= 0) return null;
  const pct = (value: number) =>
    `${String(Math.round((value / total) * 100))}%`;
  const parts = [
    read > 0 ? `${pct(read)} read` : null,
    written > 0 ? `${pct(written)} written` : null,
  ].filter((part): part is string => part !== null);
  return `${pct(read + written)} of tokens were cache: ${parts.join(', ')}.`;
}
